import axios from '../axios';

export const aiTranslateSeoPage = (pageKey, fromLocale, toLocale) => {
  return axios.post('/seo/pages/ai-translate', {
    page_key: pageKey,
    from_locale: fromLocale,
    to_locale: toLocale,
  });
};


